<template lang="pug">
div
  BaseTable(
    ref="fixedTable",
    v-if="fixedColumns.length",
    :columns = "fixedColumns",
    :classname = "fixedTableClassName",
    :sortKey = "sortKey",
    :sortOrder = "sortOrder",
    :sum = "sum",
    :sumchecked="sumchecked",
    :list = "list",
    :checkbox = "checkbox",
    :check_all = "check_all",
    :checkbox_length = "checkbox_length",
    :hasScroll = "hasScroll",
    :isFixed = "true",
    :pagetitle = "pagetitle",
    @childTableScroll = "childTableScroll"
    )
    template(:slot="item.key",
      v-for="item in fixedColumns")
      slot(:name="item.key")
    template(:slot="item.key+'-th_before'",
      v-for="item in fixedColumnsChildren")
      slot(:name="item.key+'-th_before'")
    template(:slot="item.key+'-th'",
      v-for="item in fixedColumnsChildren")
      slot(:name="item.key+'-th'")
  div(:class="{'scroll-box' : fixedColumns.length > 0}",
    @scroll="addFixedTableShadow")
    BaseTable(
      ref="scrollTable",
      :columns = "scrollColumns",
      :classname = "classname",
      :sortKey = "sortKey",
      :sortOrder = "sortOrder",
      :sum = "sum",
      :list = "list",
      :checkbox = "checkbox && !fixedColumns.length",
      :check_all = "check_all && !fixedColumns.length",
      :checkbox_length = "checkbox_length",
      :hasScroll = "hasScroll",
      :pagetitle = "pagetitle",
      @childTableScroll = "childTableScroll"
      )
      template(:slot="item.key",
        v-for="item in scrollColumns")
        slot(:name="item.key")
      template(:slot="item.key+'-th_before'",
        v-for="item in scrollColumnsChildren")
        slot(:name="item.key+'-th_before'")
      template(:slot="item.key+'-th'",
        v-for="item in scrollColumnsChildren")
        slot(:name="item.key+'-th'")
</template>

<script>
import BaseTable from './base-table.vue'
export default {
  components: {
    BaseTable
  },
  props: {
    classname: {
      type: String,
      default: 'opt-table'
    },
    columns: {
      type: Array,
      require: true
    },
    sortKey: {
      default: ''
    },
    sortOrder: {
      default: 0
    },
    sumchecked: Boolean,
    sum: {
      type: [String, Object],
      default: () => {}
    },
    list: {
      default() {
        return []
      }
    },
    check_all: false,
    checkbox: {
      default: false
    },
    checkbox_length: {
      default: 1
    },
    pagetitle: String,
  },
  computed: {
    theadHasChild() {
      return _.has(this.columns[0], 'children')
    },
    fixedTableClassName() {
      let name = this.classname + ' fixed-table'
      name += this.hasShadow ? ' fixedtable-boxshadow' : ''
      return name
    },
    hasScroll() {
      return this.fixedColumns.length > 0
    },
    fixedColumnsChildren() {
      //如果columns中单项有children
      if(this.theadHasChild){
        let children = _.reduce(this.fixedColumns, (result, item) => {
          return _.concat(result, item.children)
        }, [])
        return children
      }else {
        return this.fixedColumns
      }
    },
    scrollColumnsChildren() {
      //如果columns中单项有children
      if(this.theadHasChild){
        let children = _.reduce(this.scrollColumns, (result, item) => {
          return _.concat(result, item.children)
        }, [])
        return children
      }else {
        return this.scrollColumns
      }
    },
    fixedColumns() {
      return _.filter(this.columns, {fixed : true})
    },
    scrollColumns() {
      return _.filter(this.columns, (item) => {
        if(!item.fixed) {
          return item
        }
      })
    }
  },
  data() {
    return {
      hasShadow: false
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    addFixedTableShadow(e) {
      this.$nextTick(() => {
        this.hasShadow = e.srcElement.scrollLeft ? true : false
      })
    },
    childTableScroll({e, fixed, ref}) {
      const componentRef = fixed ? 'scrollTable' : 'fixedTable'
      const itemRef = 'table_' + ref
      if(_.has(this.$refs, componentRef)) {
        this.$nextTick(() => {
          this.$refs[componentRef].$refs[itemRef][0].scrollTop = e.srcElement.scrollTop
        })
      }
    }
  },
  destroyed () {
  }
}

</script>
<style scoped>
.scroll-box {
  overflow: auto;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ced3d9;
    border-radius: 10px;
    border-radius: 30px;
  }
  &::-webkit-scrollbar-track {
    background: #eaeced;
  }
}
.fixed-table {
  float: left;
  width: auto;
  border-right: 1px solid #dadfe6;
}
.fixedtable-boxshadow {
  box-shadow: 2px 0 5px -2px rgba(0,0,0,.2);
}
 

</style>



// WEBPACK FOOTER //
// complex-table.vue?1a074ef2